<template>
  <div>
    <!-- <div class="text-xs-right">
      <v-btn small outline color="primary" flat class="ma-0" @click="convertImageRatio">
        <span class="material-icons mr-2">
          {{ ratio == 'square' ? 'crop_16_9' : 'crop_square' }}</span
        >
        {{ $t(`Resize to ${ratio == 'square' ? 'Horizontal' : 'Square'}`) }}
      </v-btn>
    </div> -->
    <div
      style="overflow-x: auto; overflow-y: hidden; margin-bottom: 5px; margin-top: 15px"
      v-if="generics"
    >
      <div style="display: flex; margin: 0; align-items: stretch; padding-bottom: 25px">
        <div style="width: 300px; margin-right: 15px">
          <ntn-manage v-model="generics" @onDelete="onDeleteGeneric(index)" :ratio="ratio">
          </ntn-manage>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import NtnManage from '@/components/elements/NtnManage'
import MoveHorizontal from '@/components/elements/MoveHorizontal'

export default {
  props: {
    value: {
      default: undefined
    },
    ratio: { default: 'horizontal' }
  },
  components: {
    NtnManage,
    MoveHorizontal
  },
  data: function() {
    return {
      generics: undefined
    }
  },
  mounted: function() {
    this.generics = this.value
  },
  methods: {
    convertImageRatio() {
      this.$emit('changeRatio', this.ratio == 'horizontal' ? 'square' : 'horizontal')
    },
    onDeleteGeneric(index) {
      if (this.generics.length == 1) {
        this.$emit('deleteMessage')
      } else {
        this.generics.splice(index, 1)
      }
    }
  },
  watch: {
    value: function(newVal) {
      this.generics = newVal
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentNtnManage.vue